export default {
  placeholder: 'Wybierz czujnik',
};
